/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell } from 'react-table';

import { TooltipColumn } from '../types';
import { defaultCellWidth } from '../constants';

interface Props<D extends object> {
    cell: Cell<D>;
    column: TooltipColumn<D>;
}

export function ClampedTextCell<D extends object>({
    cell,
    column,
}: Props<D>): JSX.Element {
    const width = (column?.width as number) ?? defaultCellWidth;
    const text = cell.value as string | null;

    if (text === null || text.length === 0) {
        // unicode em dash
        return <>&#8212;</>;
    }

    return (
        <div
            className="respond-to-mouse clamp-2-lines-break-words text-xs"
            style={{
                width,
            }}
        >
            {text}
        </div>
    );
}
